<template>
  <v-card tile>
    <v-row class="ma-0">
      <v-card-title><h2>Email verified</h2></v-card-title>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="8" class="pa-2">
        <v-card-text>
          <p>Please complete your account details</p>
          <v-form v-model="formValid">
            <v-text-field
              label="First name"
              filled
              :rules="[rules.required]"
              required
              v-model="companyData.firstName"
            ></v-text-field>
            <v-text-field
              label="Last name"
              filled
              :rules="[rules.required]"
              required
              v-model="companyData.lastName"
            ></v-text-field>
            <v-text-field
              label="Company name"
              filled
              :rules="[rules.required]"
              required
              v-model="companyData.companyName"
            ></v-text-field>
          </v-form>
        </v-card-text>
      </v-col>
      <v-col cols="4" class="pa-2">
        <v-img
          :src="require('@/assets/images/img-registration-four@3x.png')"
          max-width="293px"
          max-height="342px"
        ></v-img>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="8" class="pa-2">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="button"
            :disabled="!formValid"
            @click.prevent="submit"
            >Next</v-btn
          >
        </v-card-actions>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { textFieldRules } from '@/common'

export default {
  props: ['companyData'],
  data: () => ({
    formValid: false,
    rules: textFieldRules,
  }),
  methods: {
    async submit() {
      this.$emit('update:companyData', this.companyData)
      this.$emit('update:step', 4)
    },
  },
}
</script>
